export interface Bonus {
  title: string
  description: string
  price: string
  image: string
}

export const bonuses: Bonus[] = [
  {
    title: 'The Home Science Lab Handbook',
    description: '30 safe biology experiments with everyday materials',
    price: '$47',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/41cb86be-7532-48ee-b3ac-8cf3e4d0962f.jpg',
  },
  {
    title: 'Biology Ready Flashcards Deck',
    description: 'Printable key-term flashcards for all 10 books',
    price: '$37',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/cc0b0384-64c0-4837-ab74-aa662393559c.jpg',
  },
  {
    title: 'Exam-Ready Question Bank & Mark Schemes',
    description: 'Practice papers with model answers',
    price: '$47',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/38e97730-835b-49eb-b145-dad00b5a7c0f.jpg',
  },
  {
    title: 'Parent & Teacher Progress Tracker',
    description: 'Plan and celebrate the full 10-book journey',
    price: '$27',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/181d9335-2ba1-4c87-9139-26291fb7d320.jpg',
  },
  {
    title: 'Biology Visual Glossary & Wall Posters',
    description: 'Illustrated posters of key systems and diagrams',
    price: '$37',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/2f9e5cfd-99b2-49e7-b776-c8e0cca5be9c.jpg',
  },
]

export interface Testimonial {
  quote: string
  name: string
  role: string
}

export const testimonials: Testimonial[] = [
  {
    quote: '“The diagrams are so clear my students finally understand cell structure the first time.”',
    name: 'Sarah M.',
    role: 'Middle School Science Teacher',
  },
  {
    quote: '“I have no biology background and I’m teaching confident lessons every week.”',
    name: 'David R.',
    role: 'Homeschool Parent',
  },
  {
    quote: '“The labs are safe, simple, and my class actually asks for more of them.”',
    name: 'Elena P.',
    role: 'Primary Science Lead',
  },
  {
    quote: '“The question bank and mark schemes saved me weeks before exam season.”',
    name: 'James T.',
    role: 'Secondary Biology Teacher',
  },
  {
    quote: '“My prep dropped from hours to minutes and the quality went up, not down.”',
    name: 'Aisha K.',
    role: 'Science Coordinator',
  },
  {
    quote: '“Our grades jumped a full band after one term using the revision tools.”',
    name: 'Marco R.',
    role: 'IB Biology Tutor',
  },
]

export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'What grades and ages does Biology Ready cover?',
    answer:
      'All 10 volumes span Grades 1 through 12 — ages 6 to 18 — with a spiral progression so concepts build year after year.',
  },
  {
    question: 'Is it aligned to a curriculum standard?',
    answer:
      'Yes. Every unit is mapped against NGSS, the UK National Curriculum and IB, so you can teach with confidence anywhere in the world.',
  },
  {
    question: 'What format are the volumes in?',
    answer: 'High-quality PDFs — print-ready and screen-ready, so you can teach on paper or from a tablet.',
  },
  {
    question: 'How do I get the pack after buying?',
    answer:
      'Instantly. Right after checkout you receive immediate digital access to download all 10 volumes and the five bonuses.',
  },
  {
    question: 'Can I use it for a whole class or multiple children?',
    answer:
      'Yes. Your licence covers your own classroom or household, so print as many copies as your students need.',
  },
  {
    question: 'Do I need a strong biology background to teach it?',
    answer:
      'Not at all. Each unit includes step-by-step teaching notes, labeled diagrams and full answer keys so you always know what to say and what to expect.',
  },
  {
    question: 'Is there a refund policy?',
    answer:
      'Yes. You are covered by a 30-day money-back guarantee. If Biology Ready is not right for you, request a full refund and keep the bonuses.',
  },
]
